"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZERO_BOUNCE_EMAIL_STATUS = void 0;
// THIS IS ZERO BOUNCE API CONSTANTS, please don't change
exports.ZERO_BOUNCE_EMAIL_STATUS = {
    VALID: 'valid',
    INVALID: 'invalid',
    CATCH_ALL: 'catchAll',
    SPAMTRAP: 'spamtrap',
    ABUSE: 'abuse',
    DO_NOT_MAIL: 'doNotMail',
    UNKNOWN: 'unknown',
    DEFAULT: ''
};
//# sourceMappingURL=zeroBounceEmailStatus.js.map